import(/* webpackMode: "eager" */ "/home/ubuntu/apps/icomm/dev/icomm/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["ListProvider"] */ "/home/ubuntu/apps/icomm/dev/icomm/components/providers/list-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SocketProvider"] */ "/home/ubuntu/apps/icomm/dev/icomm/components/providers/socket-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/home/ubuntu/apps/icomm/dev/icomm/components/theme-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/home/ubuntu/apps/icomm/dev/icomm/components/ui/toaster.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/apps/icomm/dev/icomm/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
